// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xw-1";
export var printerIcon = "_xw-0";